import React from "react";
import { Navbar } from "../Navbar/Navbar";
import { ThemeContext } from "../../Context/theme";

import "./Header.css";
export const Header = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <header className={"header center " + themename}>
        {/* The logo is stylised unicode, which crawlers and screen readers
            cannot read as a name — the label carries the real one. */}
        <div className="brand">
          <a
            href="#home"
            className="link mylast"
            aria-label="Aman Jaiswal — Frontend Developer, home"
            title="Aman Jaiswal — Frontend Developer (Angular & React)"
          >
            <span className="myv" aria-hidden="true">
              𝔸
            </span>
            <span aria-hidden="true">𝕞𝕒𝕟</span>
          </a>
        </div>
        <Navbar />
      </header>
    </>
  );
};
